import { useCallback } from 'react'

import { useActiveBookkeepingBankAccount } from '@features/accounts/hooks/useActiveBookkeepingBankAccount'
import { useDefaultBookkeepingBankAccount } from '@features/accounts/hooks/useDefaultBookkeepingBankAccount'
import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUmbrella } from '@modules-deprecated/app/umbrellas'

import { EmberRoute } from '../../../../../enums/emberRoute'
import { useEmberRouteToUrlGenerator } from '../../../../../hooks/routing/useEmberRouteToUrlGenerator'
import { replaceThirdSlash } from '../utils/replaceThirdSlash'

export const useConvertEmberRouteToUrl = () => {
  const { defaultBookkeepingBankAccount } = useDefaultBookkeepingBankAccount()
  const { activeBookkeepingBankAccount } = useActiveBookkeepingBankAccount()
  const { generateUrl } = useEmberRouteToUrlGenerator()
  const { organization } = useUserOrganization()
  const { umbrella } = useUmbrella()

  const organizationUrl = organization?.url || ''

  const convertEmberRouteToUrl = useCallback(
    (route: EmberRoute) => {
      if (!generateUrl) {
        return '#'
      }

      // Special handling for bank routes that require an account ID
      if (route === EmberRoute.Bank || route === EmberRoute.BankReact) {
        const accountId = defaultBookkeepingBankAccount?.id ?? activeBookkeepingBankAccount?.id ?? 'undefined'
        return generateUrl(route, accountId)
      }

      let url = generateUrl(route)

      if (umbrella) {
        url = replaceThirdSlash(url)
      }

      // Fix broken Ember behavior where /undefined is returned
      if (url.startsWith('/undefined') && organizationUrl) {
        url = url.replace('/undefined', `/${organizationUrl}`)
      }

      return url
    },
    [activeBookkeepingBankAccount?.id, defaultBookkeepingBankAccount?.id, generateUrl, organizationUrl, umbrella],
  )

  return { convertEmberRouteToUrl }
}
